import React from 'react';
import { useParams } from 'react-router-dom';
import WbAppWithTabs from './WbAppWithTabs';

export default function WbClientInterface() {
  const { clientId } = useParams();
  return <WbAppWithTabs clientId={clientId} />;
}
